(() => {

  const HERO_SELECTOR = '[data-fv-hero]';


  function initFutureVintageHero(root = document) {

    let heroes = [];


    if (
      root.matches &&
      root.matches(HERO_SELECTOR)
    ) {

      heroes = [root];

    }

    else {

      heroes =
        root.querySelectorAll
          ? root.querySelectorAll(HERO_SELECTOR)
          : [];

    }


    heroes.forEach((hero) => {

      /*
        Prevent duplicate listeners.
      */

      if (
        hero.dataset.fvInitialized === 'true'
      ) {

        return;

      }


      hero.dataset.fvInitialized =
        'true';


      const motionEnabled =
        hero.dataset.motion === 'true';


      const revealEnabled =
        hero.dataset.reveal === 'true';


      const strength =
        Number(
          hero.dataset.motionStrength || 8
        );


      const reducedMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;


      const coarsePointer =
        window.matchMedia(
          '(pointer: coarse)'
        ).matches;


      const panels =
        hero.querySelectorAll(
          '.fv4__panel'
        );


      /* =========================
         MOUSE MOTION
      ========================= */

      if (
        motionEnabled &&
        !coarsePointer &&
        !reducedMotion
      ) {

        panels.forEach((panel) => {

          let animationFrame = null;


          const move = (event) => {

            const rect =
              panel.getBoundingClientRect();


            if (
              rect.width <= 0 ||
              rect.height <= 0
            ) {

              return;

            }


            const normalizedX =
              (
                (
                  event.clientX -
                  rect.left
                )
                /
                rect.width
              )
              - 0.5;


            const normalizedY =
              (
                (
                  event.clientY -
                  rect.top
                )
                /
                rect.height
              )
              - 0.5;


            cancelAnimationFrame(
              animationFrame
            );


            animationFrame =
              requestAnimationFrame(() => {

                panel.style.setProperty(
                  '--fv-move-x',
                  `${normalizedX * strength}px`
                );


                panel.style.setProperty(
                  '--fv-move-y',
                  `${normalizedY * strength}px`
                );

              });

          };


          const reset = () => {

            panel.style.setProperty(
              '--fv-move-x',
              '0px'
            );


            panel.style.setProperty(
              '--fv-move-y',
              '0px'
            );

          };


          panel.addEventListener(
            'mousemove',
            move
          );


          panel.addEventListener(
            'mouseleave',
            reset
          );

        });

      }


      /* =========================
         SAFE REVEAL
      ========================= */

      if (
        revealEnabled &&
        !reducedMotion
      ) {

        /*
          Only now do we allow CSS to
          hide the panels.
        */

        hero.classList.add(
          'fv4--reveal-ready'
        );


        /*
          If already in viewport,
          reveal immediately.
        */

        const rect =
          hero.getBoundingClientRect();


        const alreadyVisible =
          rect.top < window.innerHeight &&
          rect.bottom > 0;


        if (alreadyVisible) {

          requestAnimationFrame(() => {

            hero.classList.add(
              'fv4--visible'
            );

          });

        }


        else {

          const observer =
            new IntersectionObserver(

              (entries) => {

                entries.forEach(
                  (entry) => {

                    if (
                      entry.isIntersecting
                    ) {

                      hero.classList.add(
                        'fv4--visible'
                      );


                      observer.unobserve(
                        hero
                      );

                    }

                  }
                );

              },

              {
                threshold: 0.08,
                rootMargin:
                  '40px 0px 40px 0px'
              }

            );


          observer.observe(hero);

        }

      }


      else {

        /*
          Never leave content hidden
          when reveal is disabled.
        */

        hero.classList.remove(
          'fv4--reveal-ready'
        );


        hero.classList.add(
          'fv4--visible'
        );

      }

    });

  }


  /* =========================
     NORMAL PAGE LOAD
  ========================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        initFutureVintageHero();

      }
    );

  }

  else {

    initFutureVintageHero();

  }


  /* =========================
     SHOPIFY THEME EDITOR
  ========================= */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      const hero =
        event.target.matches?.(
          HERO_SELECTOR
        )
          ? event.target
          : event.target.querySelector?.(
              HERO_SELECTOR
            );


      if (!hero) {

        return;

      }


      hero.dataset.fvInitialized =
        'false';


      hero.classList.remove(
        'fv4--reveal-ready'
      );


      hero.classList.remove(
        'fv4--visible'
      );


      initFutureVintageHero(
        event.target
      );

    }
  );


  /*
    When editing/selecting a block,
    make absolutely sure the hero
    remains visible.
  */

  document.addEventListener(
    'shopify:block:select',
    (event) => {

      const hero =
        event.target.closest?.(
          HERO_SELECTOR
        );


      if (!hero) {

        return;

      }


      hero.classList.add(
        'fv4--visible'
      );

    }
  );

})();